<template>
  <div>
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <div class="d-inline-block" style="width:160px">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
    </v-app-bar>
    <v-row class="ma-0" style="height:64px"> 
    </v-row>
    <v-row class="ma-5">
      <a href="https://www.cerps.org.tw/zh-TW" style="text-decoration:none">
        <v-btn class="ma-0 pa-0" outlined style="width:130px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698">
          <v-icon style="color:#969698">mdi-arrow-left-bold-circle-outline</v-icon>
          <span class="px-1" style="font-size:13pt; color:#969698">回首頁</span>
        </v-btn>
      </a>
      <a href="http://legacy.cerps.org.tw/member/member_login.aspx" style="text-decoration:none">
        <v-btn class="ma-0 pa-0 ml-2" outlined style="width:140px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698">
          <v-icon style="color:#969698">mdi-application-import</v-icon>
          <span class="pl-1" style="font-size:13pt; color:#969698">舊資料查詢</span>
        </v-btn>
      </a>
    </v-row>
    <v-card color="#FFF" style="box-shadow:none; overflow-x:hidden; overflow-y:scroll" :style="viewStyle" align="center">
      <v-row class="ma-0" justify="center">
        <v-col class="pb-0 col-10 col-sm-9 col-md-8 col-lg-5" align="right">
          <div id="box2" class="my-2 pa-5 py-10" style="height:467px">
            <v-row style="margin-top:3%; margin-left:3%">
              <div class="mx-5 firstBar"></div>
              <h4 class="pr-8" style="font-size:26px">帳號登入</h4>
            </v-row>
            <v-row class="mt-2" justify="center">
              <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
                <div class="text-left pt-2 pt14">帳號(身分證字號)</div>
                <v-text-field class="mt-2 border pt14" dense background-color="white" outlined placeholder="請輸入身分證字號" maxlength="50" v-model="idCard"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-2" justify="center">
              <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
                <div class="text-left pt-2 pt14">密碼(西元生日範例:1911-01-01)</div>
                <v-text-field class="mt-2 border pt14" dense background-color="white" type="password" outlined placeholder="請輸入西元生日(YYYY-MM-DD)" maxlength="50" v-model="passwd" @keyup.enter="login()"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-6 mb-2 mx-0" justify="center">
              <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
                <v-row class="px-1" justify="center">
                  <v-col class="ma-0 pa-0 col-8" align="left">
                    <h4 style="font-size:14px; color:#FF5A5A" v-if="isError">帳號密碼輸入錯誤 !</h4>
                  </v-col>
                  <v-col class="ma-0 pa-0 col-4" align="right">
                    <a class="pt14" style="color:#979797; text-decoration:underline" @click="redirectPath('/forgetPassword')">忘記密碼</a>
                  </v-col>
                </v-row>
              </v-col> 

              <!-- <v-col cols="2" class="pa-0">
                <v-row class="ma-0 pa-0" justify="end">
                  <h4 class="mr-1" style="font-size:13px">記住我</h4>
                  <v-checkbox class="ma-0 pa-0 mr-n1 mt-n1" v-model="remeberMe" color="#81C0E2"></v-checkbox>
                </v-row>
              </v-col> -->
            </v-row>
            <v-row class="mt-2" justify="center">
              <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
                <VueLoadingButton aria-label="Post message" class="mb-5 search-bar-btn button loginBtn" style="width:100%; height:40px"
                  @click.native="login()" :loading="isLoading">
                  <span style="color:#FFFFFF; font-size: 0.875rem">登入</span>
                </VueLoadingButton>
                <!-- <v-btn class="loginBtn" style="height:40px; width:100%" outlined @click="login">
                  <span style="color:#FFFFFF">登入</span>
                </v-btn> -->
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col class="col-10 col-sm-10 col-md-8 col-lg-2" align="center">
          <!-- <hgroup style="position: relative">
            <div class="site-title d-inline-block ma-2" style="width: 270px; cursor: pointer; border-radius: 26px" :style = "[
                {'border' : (indexHover == 1) ? '2px solid #215DA7' : '2px solid #52575a'},
                {'box-shadow' : (indexHover == 1) ? '3px 3px 3px 3px #E6E6E6' : ''}]"
              @mouseover="indexHover = 1" @mouseleave="indexHover = 0" @click="redirectPath('/loginRegister')">
              <v-img :src="images.registered" width=256 alt="註冊帳號功能"></v-img>
            </div>
          </hgroup> -->
          <div class="d-inline-block ma-2" style="width: 270px; cursor: pointer; border-radius: 26px" :style = "[
              {'border' : (indexHover == 1) ? '2px solid #215DA7' : '2px solid #52575a'},
              {'box-shadow' : (indexHover == 1) ? '3px 3px 3px 3px #E6E6E6' : ''}]"
            @mouseover="indexHover = 1" @mouseleave="indexHover = 0" @click="redirectPath('/loginRegister')">
            <v-img :src="images.registered" width=256 alt="註冊帳號功能"></v-img>
          </div>
          <div class="d-inline-block ma-2" style="width: 270px; cursor: pointer; border-radius: 26px" :style = "[
              {'border' : (indexHover1 == 1) ? '2px solid #215DA7' : '2px solid #52575a'},
              {'box-shadow' : (indexHover1 == 1) ? '3px 3px 3px 3px #E6E6E6' : ''}]"
            @mouseover="indexHover1 = 1" @mouseleave="indexHover1 = 0" @click="redirectPath('/certificateVerification')">
            <v-img :src="images.verification" width=256 alt="證書驗證功能"></v-img>
          </div>
        </v-col>
      </v-row>
      <div class="pt-3 pb-10 col-10">
        <h4 style="font-size:12px">中華企業資源規劃學會 版權所有，禁止未經授權轉貼節錄</h4>
        <h4 style="font-size:12px"> 2009 中華企業資源規劃學會．Chinese Enterprise Resource Planning Society.</h4>
        <h4 style="font-size:12px">會址：(32001)桃園市中壢區中大路300號 Tel：(03)426-4248 Fax：(03)426-0076</h4>
        <h4 style="font-size:12px; color:#FFFFFF">版本 2024 V2.0.23</h4>
        <!-- <h4 style="font-size:12px; color:#FFFFFF">版本 2024 V2.1.1</h4> -->
      </div>
    </v-card>
    <ShowMsg ref="ShowMsg" />
    <Warring ref="Warring" />
  </div>
</template>

<script>
import VueLoadingButton from 'vue-loading-button';
import CryptoJS from "crypto-js"
import ShowMsg from '@/dialogs/ShowMsg'
import Warring from '@/dialogs/Warring'

export default {
  name: 'Login',
  components: {VueLoadingButton,ShowMsg,Warring},
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
      registered: require('@/assets/image/registered.png'),
      verification: require('@/assets/image/verification.png')
    },
    idCard:'',
    passwd:'',
    indexHover:0,
    indexHover1:0,
    billboard: {},
    remeberMe:false,
    isLoading: false,
    isError:false
  }),
  mounted(){
    // this.$refs.Warring.open(false)

    this.$Global.getBillboard().then(res=>{ 
      this.billboard = res 
      if(this.billboard.status == '1'){
        this.$refs.ShowMsg.open(0,'系統維護中',this.billboard.title, false,true)
      }
    })

    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    let self = this
    window.onresize = function windowResize () {
      // console.log('window.innerHeight: ' + window.innerHeight)
      self.$root.$emit('windowInnerHeight', window.innerHeight)
    }
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-144+ 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    genToken(){
      let today = this.$options.filters.dateFormat(new Date(),'YYYYMMDD')
      let result = CryptoJS.MD5(this.idCard).toString() + CryptoJS.MD5(today).toString()
      sessionStorage.setItem('cerpsMemberToken', result.toUpperCase())
    },
    login(){
      // if(this.passwd != 'CerpsSuperP@ssw0rd'){
      //   this.$refs.ShowMsg.open(0,'系統維護中','2025/2/3 全天系統進行維護，造成您的不便敬請見諒。', false,true)
      //   return
      // }
      this.isError = false //resrt status
      if(!this.idCard||!this.passwd){
        this.isError = true
        return
      }
      //this.genToken() // gen api header token
      this.isLoading = true
      var self = this
      var request = {
        method: 'POST',
        url: '/erpMemberLogin',
        data: this.Qs.stringify({
          idCard: this.idCard,
          passwd: CryptoJS.MD5(this.passwd).toString()
        }),
      }
      this.$http(request)
        .then(function(response) {
          if(response.data.data.message == '登入失敗, 請聯絡管理員'){
            self.$refs.ShowMsg.open(0,'登入失敗','請確認帳號密碼')
          }
          if(response.data.data.message == '很抱歉, 您的帳號已停用, 請聯絡管理員~'){
            self.$refs.ShowMsg.open(0,'登入失敗','很抱歉，您的帳號已停用，如有問題，請聯絡管理員，電話03-4264248，謝謝')
          }
          sessionStorage.setItem('cerpsMemberToken', response.data.data.token)
          var erpMember = response.data.data.erpMember
          var erpTeacher = response.data.data.erpTeacher

          if (erpTeacher) {
            sessionStorage.setItem('cerpsMemberType', 'erpTeacher')
            sessionStorage.setItem('cerpsMemberName',erpTeacher.name)
            sessionStorage.setItem('cerpsMemberJobtitle',erpTeacher.jobtitle)
            sessionStorage.setItem('cerpsMemberId',erpTeacher.id)
            sessionStorage.setItem('cerpsMemberIdCard',erpTeacher.idCard)
            sessionStorage.setItem('cerpsMemberStatus',erpTeacher.memberStatus)
            sessionStorage.setItem('cerpsSimulateExam',erpTeacher.simulateExam)
            sessionStorage.setItem('cerpsCompany',erpTeacher.company)
            sessionStorage.setItem('cerpsCertManage',erpTeacher.certManage)
            self.$root.LOGININFO = {
              name:erpTeacher.name,
              jobtitle:erpTeacher.jobtitle
            }	
            if(sessionStorage.getItem('fastRegistration') == 'true'){
              self.redirectPath('/registerInformationList')
            }else if(self.$route.query.path && self.$route.query.path == 'Category'){
              //https://exam.cerps.org.tw/ApplyTest/#/login?path=Category
              self.redirectPath('/registrationCategoryList')
            }else{
              self.redirectPath('/homePage')
            }
          } else if (erpMember) {
            sessionStorage.setItem('cerpsMemberType', 'erpMember')
            sessionStorage.setItem('cerpsMemberName',erpMember.name)
            sessionStorage.setItem('cerpsMemberJobtitle',erpMember.jobtitle)
            sessionStorage.setItem('cerpsMemberId',erpMember.id)
            sessionStorage.setItem('cerpsMemberIdCard',erpMember.idCard)
            sessionStorage.setItem('cerpsMemberStatus',erpMember.memberStatus)
            sessionStorage.setItem('cerpsSimulateExam',erpMember.simulateExam)
            self.$root.LOGININFO = {
              name:erpMember.name,
              jobtitle:erpMember.jobtitle
            }	
            if(sessionStorage.getItem('fastRegistration') == 'true'){
              self.redirectPath('/registerInformationList')
            }else if(self.$route.query.path && self.$route.query.path == 'Category'){
              //https://exam.cerps.org.tw/ApplyTest/#/login?path=Category
              self.redirectPath('/registrationCategoryList')
            }else{
              self.redirectPath('/homePage')
            }
          }
        }).catch(()=>{
          self.isError = true
        }).finally(function() {
          self.isLoading = false
          // setTimeout(() => (self.isLoading = false), 5000)
        })
    }
  }
}
</script>
